import api, { unwrapList, unwrapOne } from "./apiClient";
import { BACKEND_URL } from "@/config/api";

const API_BASE = `${BACKEND_URL}/ingredients`;

/**
 * Ingredient Service (IngredientsController - /ingredients)
 * IngredientsDTO: { id, name, price, visible ('S'/'N') }
 * A API não tem DELETE: para tirar um ingrediente de uso, oculte-o
 * (visible = 'N').
 */
class IngredientService {
  /**
   * Todos os ingredientes da empresa, do mais recente ao mais antigo (a API
   * monta a lista com HashSet, sem ordem garantida). Empresa sem ingredientes
   * recebe 404 da API: aqui vira [] sem abrir o modal global.
   * @param {object} [options] - config extra do axios (ex.: { silent: true })
   */
  async getAll(options = {}) {
    try {
      const response = await api.get(API_BASE, { silentStatuses: [404], ...options });
      return unwrapList(response).sort((a, b) => Number(b.id) - Number(a.id));
    } catch (error) {
      if (error.response?.status === 404) return [];
      console.error("❌ Erro ao buscar ingredientes:", error);
      throw error;
    }
  }

  /** Ingredientes visíveis (usados como extras) */
  async getExtras() {
    try {
      const response = await api.get(`${API_BASE}/extras`);
      return unwrapList(response);
    } catch (error) {
      console.error("❌ Erro ao buscar ingredientes extras:", error);
      throw error;
    }
  }

  async getById(id) {
    try {
      const response = await api.get(`${API_BASE}/${id}`);
      return unwrapOne(response);
    } catch (error) {
      console.error(`❌ Erro ao buscar ingrediente ${id}:`, error);
      throw error;
    }
  }

  async create(ingredient) {
    try {
      const response = await api.post(API_BASE, ingredient);
      return unwrapOne(response);
    } catch (error) {
      console.error("❌ Erro ao criar ingrediente:", error);
      throw error;
    }
  }

  async update(id, ingredient) {
    try {
      const response = await api.put(`${API_BASE}/${id}`, ingredient);
      return unwrapOne(response);
    } catch (error) {
      console.error(`❌ Erro ao atualizar ingrediente ${id}:`, error);
      throw error;
    }
  }

  /**
   * Oculta/exibe o ingrediente (substitui a exclusão)
   * @param {object} ingredient
   * @param {boolean} visible
   */
  async setVisible(ingredient, visible) {
    return this.update(ingredient.id, {
      ...ingredient,
      visible: visible ? "S" : "N",
    });
  }
}

export default new IngredientService();
